export enum BioRoutes {
    PLUMA = 'la-pluma',
    DIAS_Y_HORAS = 'los-dias-y-las-horas',
    REVISTA_VUELO = 'la-revista-vuelo',
    CARICATURA = 'una-caricatura',
    DISCO = 'el-disco',
    REVISTA_VIDA = 'la-revista-vida',
    TEATRINO = 'el-pleito-del-queso',
    MYDAS = 'libro-mydas',
    DEDICATORIA = 'una-dedicatoria'
}